import { Auth } from "@aws-amplify/auth";

import { handleError } from "../common/ErrorUtil";

/**
 * サインアウトAPIの実行.
 *
 * @return {object} レスポンス
 */
export async function executeSignOut() {
  const params = {
    global: true,
  };
  const response = await Auth.signOut(params).catch(handleError);
  return response;
}

export default executeSignOut;
